import React, {FC} from 'react';
import styled from 'styled-components';

import {defineMessage, Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {fontSizes} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {useLocalize} from '../../../../../srcCommon/internationalization/internationalizationContext';
import conversationListImage from '../../../../assets/images/conversationList.svg';
import workspaceImage from '../../../../assets/images/workspace.svg';
import {useAppSelector} from '../../../../helpers/reduxHelpers';
import {getHasPreventPinTeamTags} from '../../../../store/featureFlags/featureFlagsSelectors';
import {ComplexTooltipContent} from '../../tooltips/complexTooltipContent';

/*
 * Style.
 */

const StyledComplexTooltipContent = styled(ComplexTooltipContent)`
  box-sizing: border-box;
  max-width: 220px;

  padding: 8px 0 0 0;

  div {
    margin-left: 10px;
    margin-right: 10px;

    line-height: 150%;
  }

  div:first-child {
    font-size: ${fontSizes.medium};
    margin-bottom: 0px;
  }

  div:not(:first-child) {
    font-size: ${fontSizes.verySmall};
    margin-bottom: -4px;
  }

  img {
    height: auto;
    width: 220px;
    margin-bottom: -5px;
  }
`;

/*
 * Components.
 */

export const ShowTagInWorkspacesTooltip: FC = () => {
  const localize = useLocalize();
  const hasPreventPinTeamTags = useAppSelector(getHasPreventPinTeamTags);

  return (
    <StyledComplexTooltipContent
      maxWidth={240}
      title={<Trans id="tageditor-showinsidebar-tooltipheader">What&apos;s a sidebar?</Trans>}
      body={
        hasPreventPinTeamTags ? (
          <Trans id="tageditor-showinsidebar-tooltipbody-prevent-pin-team-tags">
            The sidebar displays your visible inboxes, private tags, and views. Show or hide items to focus on
            what&apos;s important.
          </Trans>
        ) : (
          <Trans id="tageditor-showinsidebar-tooltipbody">
            The sidebar displays your visible inboxes, tags, views, and teammates. Show or hide items to focus
            on what&apos;s important.
          </Trans>
        )
      }
      imageUrl={workspaceImage}
      imageDescription={localize(
        defineMessage({
          id: 'tageditor-showinworkspaces-workspacesimage',
          message: 'workspaces image',
        }),
      )}
    />
  );
};

export const ShowTagInCellsTooltip: FC = () => {
  const localize = useLocalize();
  const hasPreventPinTeamTags = useAppSelector(getHasPreventPinTeamTags);

  return (
    <StyledComplexTooltipContent
      maxWidth={240}
      title={<Trans id="tageditor-showincells-tooltipheader">What&apos;s a conversation list?</Trans>}
      body={
        hasPreventPinTeamTags ? (
          <Trans id="tageditor-showincells-tooltipbody-prevent-pin-team-tags">
            Conversation lists are where your messages live. The list changes based on the inbox, private tag,
            or view you select on the left.
          </Trans>
        ) : (
          <Trans id="tageditor-showincells-tooltipbody">
            Conversation lists are where your messages live. The list changes based on the inbox, tag, or
            teammate you select on the left.
          </Trans>
        )
      }
      imageUrl={conversationListImage}
      imageDescription={localize(
        defineMessage({
          id: 'tageditor-showinworkspaces-conversationlist',
          message: 'conversation list image',
        }),
      )}
    />
  );
};
